function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(90.147 -83.276)",
  id: "layer1",
  fillOpacity: 1,
  stroke: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 0,
  strokeOpacity: 1
}, /*#__PURE__*/React.createElement("path", {
  id: "path2450",
  d: "M-90.147 145.145l35.715-61.869 35.723 61.869-15.875-.004-19.846-34.369-19.841 34.369z",
  opacity: 1,
  fill: "#4acfac",
  strokeWidth: 0.624
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.686 145.145l35.715-61.869 35.723 61.869-15.875-.004-19.846-34.369-19.841 34.369z",
  id: "path2446",
  opacity: 1,
  fill: "#4acfac",
  strokeWidth: 0.624
}), /*#__PURE__*/React.createElement("path", {
  id: "path2442",
  d: "M89.77 145.145l35.714-61.869 35.723 61.869-15.875-.004-19.846-34.369-19.84 34.369z",
  opacity: 1,
  fill: "#4acfac",
  strokeWidth: 0.624
}), /*#__PURE__*/React.createElement("path", {
  transform: "scale(.26458)",
  d: "M339.285 314.744l134.986 233.834 135.014-233.834-60 .016-75.006 129.896-74.99-129.896z",
  id: "path1198",
  opacity: 1,
  fill: "#ffa48e",
  strokeWidth: 2.357
}), /*#__PURE__*/React.createElement("path", {
  id: "path2444",
  d: "M39.234 185.845l35.722-61.865-71.441-.002 7.941 13.746 39.687.002-19.844 34.367z",
  opacity: 1,
  fill: "#ffa48e",
  strokeWidth: 0.624
}), /*#__PURE__*/React.createElement("path", {
  d: "M-58.397 145.145l35.715-61.869 35.723 61.869-15.875-.004-19.846-34.369-19.841 34.369z",
  id: "path2448",
  opacity: 1,
  fill: "#ffa48e",
  strokeWidth: 0.624
}));

var SvgMaxlogo = function SvgMaxlogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1857",
    viewBox: "0 0 251.354 102.569",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaxlogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maxlogo.66d700d7.svg";
export { ForwardRef as ReactComponent };